<div class="dialog-header header-simple">
  <h2 mat-dialog-title>{{ dialogTitle }}</h2>
  <button mat-icon-button color="primary" (click)="cancel()" type="button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <h3 class="section-title">{{ 'columnOrganizer.visibleColumns' | transloco }}</h3>
  <div cdkDropList #visibleList="cdkDropList" [cdkDropListData]="visibleColumns" [cdkDropListConnectedTo]="[availableList]" class="column-list" (cdkDropListDropped)="drop($event)">
    <div class="column-item" *ngFor="let column of visibleColumns" cdkDrag>
      <mat-icon class="drag-handle" cdkDragHandle>drag_indicator</mat-icon>
      <span class="column-label">{{ column.labelKey | transloco }}</span>
      <button mat-icon-button class="visibility-toggle" (click)="hideColumn(column)" type="button" [matTooltip]="'columnOrganizer.hideColumn' | transloco">
        <mat-icon class="visibility-icon">visibility</mat-icon>
      </button>
    </div>
    <p class="empty-hint" *ngIf="visibleColumns.length === 0">{{ 'columnOrganizer.noVisibleColumns' | transloco }}</p>
  </div>

  <div class="available-header">
    <h3 class="section-title">{{ 'columnOrganizer.availableColumns' | transloco }}</h3>
    <mat-form-field appearance="outline" class="search-field" subscriptSizing="dynamic">
      <input matInput [(ngModel)]="searchTerm" [placeholder]="'columnOrganizer.searchPlaceholder' | transloco" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
  <div
    cdkDropList
    #availableList="cdkDropList"
    [cdkDropListData]="availableColumns"
    [cdkDropListConnectedTo]="[visibleList]"
    class="column-list"
    (cdkDropListDropped)="drop($event)">
    <div class="column-item" *ngFor="let column of filteredAvailableColumns" cdkDrag>
      <mat-icon class="drag-handle" cdkDragHandle>drag_indicator</mat-icon>
      <span class="column-label">{{ column.labelKey | transloco }}</span>
      <button mat-icon-button class="visibility-toggle" (click)="showColumn(column)" type="button" [matTooltip]="'columnOrganizer.showColumn' | transloco">
        <mat-icon class="visibility-icon">visibility_off</mat-icon>
      </button>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button type="button" (click)="cancel()">
    {{ 'common.buttons.cancel' | transloco }}
  </button>
  <button mat-raised-button color="primary" type="button" (click)="save()">
    {{ 'common.buttons.save' | transloco }}
  </button>
</mat-dialog-actions>
